export default __webpack_public_path__ + "static/media/林守德.0601471a.jpg";